<template>
  <!-- Pass the dynamic data down to MonthTicketPay via props -->
  <div v-if="!carNumberEntered">
    <CarNumber @updateState="handleUpdateState" @query-parking-fee="fetchBills" />
  </div>
  <div v-if="showBillList">
    <MonthTicketPay :carNumber="carNumber" :currentBills="myCurrentBills" :historicalBills="myHistoricalBills" @show-bill-details="showBill" />
  </div>
  <div v-if="showBarcodeBill">
    <BarCodeBill :bankName="barcodeBillDetails.bankName" :bankId="barcodeBillDetails.bankId"
      :amount="barcodeBillDetails.amount" :accountNo="barcodeBillDetails.accountNo"
      :dueDate="barcodeBillDetails.dueDate" :barcodes="barcodeBillDetails.barcodes" :depName="barcodeBillDetails.depName"
      :QR_ID="barcodeBillDetails.QR_ID"
      @go-bill-list="goBillList" />
  </div>

  <!-- LoadingSpinner component -->
  <LoadingSpinner v-if="isLoading" loadingText="查詢繳費資料中..." />


</template>

<script>
import { mapGetters } from 'vuex';
import { globalParams } from '@/global.js';



import MonthTicketPay from './MonthTicketPay.vue';
import BarCodeBill from './BarCodeBill.vue';
import CarNumber from './CarNumber.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { logApi } from '@/util/util';

// const billAPIURL = 'http://172.233.151.241:5000';
// VUE_APP_TWPK_BILL_API_URL="https://172.233.151.241/faraday"
const billAPIURL = process.env.VUE_APP_TWPK_BILL_API_URL;


export default {
  components: {
    MonthTicketPay,
    BarCodeBill,
    CarNumber,
    LoadingSpinner
  },
  computed: {
    ...mapGetters(['user']),
  },
  data() {
    return {
      myCurrentBill: {
        // Provide default values; they'll be updated by the API call
        date: '',
        description: '本期帳單',
        amount: 0,
        status: 'unpaid', // or 'paid'
        dueDate: '',
        Bar1: '',
        Bar2: '',
        Bar3: '',
        QR_ID: ''
      },
      myHistoricalBills: [],
      carNumber: '',            // New data property
      barcodeBillDetails: {},
      showBarcodeBill: false,
      carNumberEntered: false, // New data property
      showBillList: false,
      isLoading: false,

      depNameDict: {}

    };
  },
  mounted() {

    this.depNameDict = this.createDepNameDict(globalParams.parkings);
    // When this component is mounted, fetch data from the Flask APIs
    // this.fetchHistoricalBills();
    // this.fetchCurrentBill();
    console.log('depNameDict', this.depNameDict);
  },
  methods: {
    getDepName(depID) {
      try {
         return this.depNameDict[depID];
      } catch (error) {
        console.error('Error fetching depName:', error);
        return '';
      }
    },
    createDepNameDict(parkings) {
      const depNameDict = {};
      for (const parking of parkings) {
        depNameDict[parking.parking_id] = parking.title;
      }
      // console.log('depNameDict', depNameDict);
      return depNameDict;
    },

    handleUpdateState(payload) {
      if (payload.key === 'carNumber') {
        this.carNumber = payload.value;
      }
    },
    goBillList() {
      this.showBarcodeBill = false;
      this.showBillList = true;
    },
    resetBill() {
      this.showBarcodeBill = false;
      this.carNumberEntered = false;
      this.carNumber = '';
      this.myCurrentBill = {
        date: '',
        description: '本期帳單',
        amount: 0,
        status: 'unpaid',
        dueDate: '',
        Bar1: '',
        Bar2: '',
        Bar3: '',
        QR_ID: ''
      };
      this.myCurrentBills = [
      {
        date: '',
        description: '本期帳單',
        amount: 0,
        status: 'unpaid',
        dueDate: '',
        Bar1: '',
        Bar2: '',
        Bar3: '',
        QR_ID: ''
      }

      ];
      this.myHistoricalBills = [];
    },
    async fetchBills() {

      this.isLoading = true;
      if (this.carNumber.trim() === '') {
        alert('請輸入有效的車牌號碼');
        this.isLoading = false;
        return;
      }

      let gotCurrentBill = false;
      let gotHistoricalBill = false;

      try {
        await this.fetchCurrentBill();

        gotCurrentBill = true;

      } catch (error) {
        console.error('Error fetching bills:', error);
        // alert('查無資料，請檢查車牌號碼');
      }


      try {
          // Fetch historical bills
          await this.fetchHistoricalBills();
          gotHistoricalBill = true;
        } catch (error) {
          console.error('Error fetching historical bills:', error);
          // alert('查無資料，請檢查車牌號碼');
        }


        if (!gotCurrentBill && !gotHistoricalBill) {
          let payload = this.setPayLoad();

          alert('查無帳單資訊，請確認帳號與手機號碼相符: ' + payload.MobilePhone + '，承租車號: ' + payload.CarNo + '， 以上資訊是否正確');
          this.isLoading = false;
          return;
        }

        this.carNumberEntered = true;
        this.showBillList = true;


      this.isLoading = false;
    },

    setPayLoad() {
      let payload = {
        MobilePhone: this.user,
        CarNo: this.carNumber
      };

      if (this.user === "7") {
        switch (this.carNumber) {
          // unpaid cases
          case "ATL0102":
            payload.MobilePhone = "0987956414";
            break;
          case "ARE9669":
            payload.MobilePhone = "0937820286";
            break;
          case "BRF5676":
            payload.MobilePhone = "0933510340";
            break;
          case "8692PM":
            payload.MobilePhone = "0937103088";
            break;
          case "BMT1680":
            payload.MobilePhone = "0976560073";
            break;
          // paid cases
          case "BTA0081":
            payload.MobilePhone = "0918015518";
            break;
          case "ANU7255":
            payload.MobilePhone = "0910869841";
            break;
          case "APB1110":
            payload.MobilePhone = "0987526333";
            break;
          case "931GSF":
            payload.MobilePhone = "0989166622";
            break;
          case "BFM2831":
            payload.MobilePhone = "0958623739";
            break;
          case "BMP9136":
            payload.MobilePhone = "0987110570";
            break;
          // no-bill cases
          case "9057ANM":
            payload.MobilePhone = "0986009317";
            break;
          case "ANY9700":
            payload.MobilePhone = "0988212131";
            break;
          case "EBA9898":
            payload.MobilePhone = "0988789612";
            break;
          default:
            // fallback test account
            payload.MobilePhone = "7";
            // payload.CarNo = "MKD9519";
        }
      }

      return payload;
    },

    // 1. Fetch historical bills from /api/rent
    async fetchHistoricalBills() {
      const payload = this.setPayLoad();
      const apiUrl = billAPIURL + '/api/rent';
      let logged = false; // 成功路徑已記錄時，catch 不再重複記
      try {
        console.log('bilapiurl', apiUrl);

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        // parse and log the JSON body
        const data = await response.json();
        console.log('Response JSON:', data);
        logApi({
          api_name: 'bill_history', method: 'POST', url: apiUrl,
          request_data: payload, response_data: data, status_code: response.status,
        });
        logged = true;
        if (!response.ok) {
          console.error('Error status:', response.status);
          if (data && data.message) {
            console.error('Server message:', data.message);
            // alert(data.message);
          }
          throw new Error(`Network response was not ok. Status: ${response.status}`);
        }
        const result = data;

        console.log('histry bill result', result);

        // Transform each bill into the format expected by MonthTicketPay
        this.myHistoricalBills = result.map((bill) => {
          return {
            // Convert "CRYM" (e.g. "202410") to date string "2024-10-01"
            date: this.formatCrymToDate(bill.CRYM),
            amount: bill.PayAmt,
            // Convert "Status": "2" => 'paid', anything else => 'unpaid'
            status: bill.Status === '2' ? 'paid' : 'unpaid',
            DepName: this.getDepName(bill.DepID)
          };
        });
      } catch (error) {
        if (!logged) {
          logApi({
            api_name: 'bill_history', method: 'POST', url: apiUrl,
            request_data: payload, error_message: String(error),
          });
        }
        console.error('Error fetching historical bills:', error);
        throw error;
      }
    },

    getCurrentYearMonth() {
      const now = new Date();


      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      if (now.getDate() <= 15) { // 15 and before count as previous month
        month -= 1;
        if (month === 0) {
          month = 12;
          year -= 1;
        }
      }
      return `${year}${String(month).padStart(2, '0')}`;
    },

    // 2. Fetch current bill from /api/payment
    async fetchCurrentBill() {
      const payload = this.setPayLoad();
      const apiUrl = billAPIURL + '/api/payment';
      let logged = false; // 成功路徑已記錄時，catch 不再重複記
      try {

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          logApi({
            api_name: 'bill_current', method: 'POST', url: apiUrl,
            request_data: payload, status_code: response.status,
            error_message: 'HTTP ' + response.status,
          });
          logged = true;
          throw new Error(`Network response was not ok. Status: ${response.status}`);
        }

        // Example response:
        // {
        //   "Bar1": "131205627",
        //   "Bar2": "9712830820013222",
        //   "Bar3": "131294000006000",
        //   "DueOfPay": "6000",
        //   "QR_ID": "1E5E93BFE91B4C897FAA358DCEA1B92DB6CBBDF7B16D29FD"
        // }
        const results = await response.json();

        console.log('result', results);
        logApi({
          api_name: 'bill_current', method: 'POST', url: apiUrl,
          request_data: payload, response_data: results, status_code: response.status,
        });
        logged = true;

        const currentBills = [];

        for (const result of results) {

          //bill date is the first day of the month
          // const billDate = this.formatCrymToDate(currentYearMonth);
          // calcuate the due date , it is the last day of the month
          // const dueDate = new Date(year, month, 0);

          const billDate = this.formatCrymToDate(result.CRYM);
          // console.log('dueDate', dueDate);
          // const dueDateString = this.formatLocalDate(dueDate);


          console.log('result.DueOfPay', result.DueOfPay, typeof result.DueOfPay);
          const billAmount = Number(result.DueOfPay);
          console.log('billAmount', billAmount, typeof billAmount);

          const billStatusCode = Number(result.Status);
          const billStatus = billStatusCode === 2 ? 'paid' : 'unpaid';
          // status: bill.Status === '2' ? 'paid' : 'unpaid',


          // We only care about certain fields to display
          const myCurrentBill = {
            // For a date, you might infer "2025-01-01" from CRYM or another logic
            date: billDate,

            description: '本期帳單',
            amount: billAmount,
            // We'll assume it's 'unpaid' until we have logic to confirm otherwise
            status: billStatus,
            // Hardcode or compute the due date
            // dueDate: dueDateString,
            accountNo: result.Bar2,
            // Extract the barcode values
            Bar1: result.Bar1,
            Bar2: result.Bar2,
            Bar3: result.Bar3,
            QR_ID: result.QR_ID,
            DepName: this.getDepName(result.DepID)
          };

          currentBills.push(myCurrentBill);
        }

        this.myCurrentBills = currentBills;
      } catch (error) {
        if (!logged) {
          logApi({
            api_name: 'bill_current', method: 'POST', url: apiUrl,
            request_data: payload, error_message: String(error),
          });
        }
        console.error('Error fetching current bill:', error);
        throw error;
      }
    },

    /**
     * Helper: transform CRYM (e.g. "202410" => "2024-10-01")
     */
    formatCrymToDateX(crym) {
      if (crym.length === 6) {
        let year = parseInt(crym.slice(0, 4));
        let month = parseInt(crym.slice(4, 6));
        if (month === 12) {
          year += 1;
          month = 1;
        } else {
          month += 1;
        }
        const monthStr = String(month).padStart(2, '0');
        return `${year}-${monthStr}-01`;
      }
      return crym; // fallback if unexpected format
    },

    formatCrymToDate(crym) {
      if (crym.length === 6) {
        let year = parseInt(crym.slice(0, 4));
        let month = parseInt(crym.slice(4, 6));
        // if (month === 12) {
        //   year += 1;
        //   month = 1;
        // } else {
        //   month += 1;
        // }
        const monthStr = String(month).padStart(2, '0');
        return `${year}-${monthStr}-01`;
      }
      return crym; // fallback if unexpected format
    },


    formatLocalDate(date) {
      const year = date.getFullYear();
      // getMonth() is zero-based, so add 1; then pad with leading zero if needed
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`; // "YYYY-MM-DD"
    },

    showBill(details) {
      console.log('showBill details', details);
    // showBill  
      this.barcodeBillDetails = details;
      this.showBarcodeBill = true;
      // this.carNumberEntered = false; // Optionally hide MonthTicketPay
      this.showBillList = false;
      // Optionally hide MonthTicketPay
      // this.showBillList = false;
    }
  }
};
</script>
